import React from "react";
import {useLocation} from "react-router-dom";
import {observer} from "mobx-react-lite";
import VillageCalendarsCreateEditTemplate from "../../../../components/templates/villageCalendars/villageCalendarsCreateEditTemplate";
import {useStores} from "../../../../stores/useStores";
import {VillageCalendarConfigPayload} from "../../../../shared/interfaces/villageCalendarConfig";

/* istanbul ignore file */
const CreateVillageCalendar: React.FC = () => {
  const {
    domainStore: {villageCalendarsDomainStore}
  } = useStores();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const villageIdParam = params.get("forVillageId");
  const defaultVillageId =
    villageIdParam && villageIdParam.trim().length > 0
      ? villageIdParam
      : undefined;
  const defaultVillageName =
    defaultVillageId != null
      ? villageCalendarsDomainStore.villageCalendarsByVillage.find(
          (g) => g.villageId === defaultVillageId
        )?.villageName
      : undefined;

  const onSave = async (payload: VillageCalendarConfigPayload) => {
    await villageCalendarsDomainStore.createVillageCalendar(payload);
  };

  return (
    <VillageCalendarsCreateEditTemplate
      defaultVillageId={defaultVillageId}
      defaultVillageName={defaultVillageName}
      lockVillage={defaultVillageId != null}
      onSave={onSave}
    />
  );
};

export default observer(CreateVillageCalendar);
